import actionTypes from './actionTypes';

export const initialState = {
  results: [],
  isLoading: false,
};

export default function (state = initialState, action) {
  switch(action.type) {
    case actionTypes.FETCH_HU_LOCAL_RESULTS:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_HU_LOCAL_RESULTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        results: action.results,
      };
    case actionTypes.FETCH_HU_LOCAL_RESULTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/local/reducer.js